export default "__VITE_ASSET__0671168c__$_?nuxt_component=async__"